module.exports = require('./_global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_html.js
 ** module id = 51
 ** module chunks = 0 1
 **/